import constants from '../constants';
import { Action } from '../../../types/Global';

const initialState = {};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case constants.TOGGLE_MODAL: {
      const { isOpen, name, items } = action.payload;
      return {
        ...state,
        [name]: { isOpen, items },
      };
    }

    default: {
      return state;
    }
  }
};

export type AppState = ReturnType<typeof reducer>;

export default reducer;
